@if (!collapsed()) {
    <a
        class="side-nav__item"
        [ngClass]="itemClasses(item())"
        mat-list-item
        [routerLink]="isDisabled(item()) ? null : item().route"
        (click)="onItemClick($event, item())"
        [attr.aria-disabled]="item().disabled"
    >
        @if (item().icon) {
            <div class="side-nav__icon" matListItemIcon>
                <img [src]="item().icon" alt="icon" />
            </div>
        }
        <span matListItemTitle>{{ item().label | translate }}</span>
        @if (item().subItems?.length) {
            <span matListItemMeta>
                <img [src]="'images/' + (nestedMenuOpen() ? 'menuUp' : 'menuDown') + '.svg'" alt="" />
            </span>
        }
    </a>
    @if (item().subItems && nestedMenuOpen()) {
        <div>
            @for (subItem of item().subItems; track subItem.label) {
                <pims-menu-item [item]="subItem" [collapsed]="collapsed()" [level]="level() + 1" />
            }
        </div>
    }
}

@if (collapsed()) {
    @if (!item().subItems) {
        <a
            class="side-nav__item"
            [ngClass]="itemClasses(item())"
            mat-list-item
            [routerLink]="isDisabled(item()) ? null : item().route"
            (click)="onItemClick($event, item())"
            [attr.aria-disabled]="item().disabled"
        >
            @if (item().icon) {
                <div class="side-nav__icon" matListItemIcon>
                    <img [src]="item().icon" alt="icon" />
                </div>
            }
        </a>
    }
    @if (item().subItems) {
        <mat-list-item
            class="side-nav__item"
            [ngClass]="itemClasses(item())"
            (click)="trigger.toggleMenu()"
            [routerLink]="isDisabled(item()) ? null : item().route"
            [attr.aria-disabled]="item().disabled"
        >
            @if (item().icon) {
                <div class="side-nav__icon" matListItemIcon>
                    <img [src]="item().icon" alt="icon" />
                </div>
            }
            <div [matMenuTriggerFor]="menu" #trigger="matMenuTrigger"></div>
        </mat-list-item>
        <mat-menu #menu="matMenu" class="side-nav__menu-panel">
            @for (subItem of item().subItems; track subItem.label) {
                <a
                    mat-menu-item
                    [disableRipple]="true"
                    [routerLink]="subItem.disabled ? null : subItem.route"
                    [ngClass]="{
                        'side-nav__menu-item--active': isActive(subItem),
                        'side-nav__menu-item--disabled': !!subItem.disabled,
                    }"
                    (click)="onSubItemClick($event, subItem)"
                    [attr.aria-disabled]="subItem.disabled"
                >
                    {{ subItem.label | translate }}
                </a>
            }
        </mat-menu>
    }
}
